import { ReactNode, memo } from "react"

interface SkeletonProps {
  children?: ReactNode
  className?: string
  defaultValue?: string
  disabled?: boolean
}

export const Skeleton: React.FC<SkeletonProps> = memo(
  (props: SkeletonProps) => {
    return (
      <span
        aria-hidden={props.disabled ? undefined : true}
        className={`relative ${props.className || ""}`}
      >
        {!props.disabled && (
          <>
            <span className="absolute inset-0 z-10 rounded bg-zinc-900" />
            <span className="absolute inset-0 z-10 animate-pulse rounded bg-zinc-800" />
          </>
        )}
        {props.disabled ? props.children : props.defaultValue || props.children}
      </span>
    )
  }
)

Skeleton.displayName = "Skeleton"
